import { Col, FormGroup } from "reactstrap";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import { CreatableSelectField } from "../Utils/CreatableSelectField";
import {
  handleChangeForCity,
  handleChangeForCountry,
  handleChangeForState,
} from "../Customers/constants/HandleChangeFunctions";
import InputField from "../Utils/InputField";

export default function FormLine2({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  initialValues,
  options,
  optionState,
  optionCity,
  setFieldValue,
  setFieldTouched,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  setCities,
}) {
  return (
    <>
      <Col xxl={3} md={6}>
        <div>
          <LabelText
            htmlFor={"choices-single-default"}
            className={"text-danger"}
            displayText={"Country"}
            important={"*"}
          />
          <LabelText
            htmlFor={"choices-single-default"}
            displayText={"Select Your Country"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.country && errors.country
                ? "rv-label-danger"
                : "rv-label-muted"
            } `}
          />
          <SelectField
            className={errors.country && touched.country ? "error-input" : ""}
            value={
              initialValues?.country
                ? options?.find(
                    (country) => country.label === initialValues?.country
                  )
                : values?.country
            }
            placeholder={" "}
            handleChange={handleChangeForCountry(
              setSelectedCountry,
              setFieldValue,
              setFieldTouched,
              setSelectedState,
              setSelectedCity,
              setCities
            )}
            isClearable={true}
            options={[...options]}
            isRVStyle={true}
          />
          {/* {touched.country && errors.country && (
            <p className="text-danger validation-font-size">{errors.country}</p>
          )} */}
        </div>
      </Col>

      <Col xxl={3} md={6}>
        <div>
          <FormGroup>
            <LabelText
              htmlFor={"choices-single-default"}
              className={"text-danger"}
              displayText={"State"}
              important={"*"}
            />
            <LabelText
              htmlFor={"choices-single-default"}
              classLabelName={`d-block ms-0 rv-sub-label ${
                touched.state && errors.state
                  ? "rv-label-danger"
                  : "rv-label-muted"
              } `}
              displayText={"Select Your State"}
            />
            <SelectField
              className={errors.state && touched.state ? "error-input" : ""}
              value={
                initialValues?.state
                  ? optionState?.find(
                      (state) => state.label === initialValues?.state
                    )
                  : values?.state
              }
              placeholder=" "
              handleChange={handleChangeForState(
                setSelectedState,
                setFieldValue
              )}
              options={[...optionState]}
              isClearable={true}
              isDisabled={!values?.country}
              isRVStyle={true}
            />
            {/* {touched.state && errors.state && (
              <p className="text-danger validation-font-size">{errors.state}</p>
            )} */}
          </FormGroup>
        </div>
      </Col>

      <Col xxl={3} md={6}>
        <div>
          <LabelText
            htmlFor={"choices-single-default"}
            className={"text-danger"}
            displayText={"City"}
            important={"*"}
          />
          <LabelText
            htmlFor={"choices-single-default"}
            classLabelName={`d-block ms-0 rv-sub-label ${
              touched.city && errors.city ? "rv-label-danger" : "rv-label-muted"
            } `}
            displayText={"Select Your City"}
          />
          {/* <CreatableSelectField
            className={errors?.city && touched?.city ? "error-input" : ""}
            values={values?.city}
            placeholder={" "}
            handleChange={(value) => {
              setFieldValue(`city`, value, false);
              setFieldTouched(`city`, false);
            }}
            onKeyDown={(event) => {
              const key = event.key;
              const regex = /^[a-zA-Z0-9]$/;
              if (
                regex.test(key) ||
                [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Enter",
                ].includes(key)
              ) {
                return;
              }
              event.preventDefault();
            }}
            name={"city"}
            options={optionCity}
            fieldName={"city"}
            setFieldValue={setFieldValue}
            errors={errors.city}
            isClearable={true}
            isDisabled={!values.state}
            handleBlur={handleBlur}
            touched={touched.city}
            isRVStyle={true}
          /> */}
          <SelectField
            className={errors?.city && touched?.city ? "error-input" : ""}
            value={
              initialValues?.city
                ? optionCity?.find((city) => city.label === initialValues?.city)
                : values?.city
            }
            placeholder=" "
            handleChange={handleChangeForCity(setSelectedCity, setFieldValue)}
            options={[...optionCity]}
            isClearable={true}
            isDisabled={!values?.state}
            isRVStyle={true}
          />
        </div>
      </Col>

      <Col xxl={3} md={6}>
        <LabelText htmlFor={"zipCode"} displayText={"ZipCode"} />
        <LabelText
          htmlFor={"zipCode"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.zipCode && errors.zipCode
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.zipCode && errors.zipCode
              ? errors.zipCode
              : "Enter Your Zip Code"
          }
        />
        <InputField
          name={"zipCode"}
          placeholder={" "}
          type={"text"}
          className={"form-control"}
          id={"zipCode"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.zipCode || ""}
          isRVStyle={true}
        />
      </Col>
    </>
  );
}
